var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
export var createMediaRecorderConstructor = function (createNativeMediaRecorder, createNotSupportedError, createWebAudioMediaRecorder, createWebmPcmMediaRecorder, encoderRegexes, eventTargetConstructor, nativeMediaRecorderConstructor) {
    return /** @class */ (function (_super) {
        __extends(MediaRecorder, _super);
        function MediaRecorder(stream, options) {
            if (options === void 0) { options = {}; }
            var _this = this;
            var mimeType = options.mimeType;
            if (nativeMediaRecorderConstructor !== null &&
                // Bug #10: Safari does not yet implement the isTypeSupported() method.
                (mimeType === undefined ||
                    (nativeMediaRecorderConstructor.isTypeSupported !== undefined &&
                        nativeMediaRecorderConstructor.isTypeSupported(mimeType)))) {
                var internalMediaRecorder = createNativeMediaRecorder(nativeMediaRecorderConstructor, stream, options);
                _this = _super.call(this, internalMediaRecorder) || this;
                _this._internalMediaRecorder = internalMediaRecorder;
            }
            else if (mimeType !== undefined && encoderRegexes.some(function (regex) { return regex.test(mimeType); })) {
                _this = _super.call(this) || this;
                // Bug #10: Safari does not yet implement the isTypeSupported() method.
                if (nativeMediaRecorderConstructor !== null &&
                    nativeMediaRecorderConstructor.isTypeSupported !== undefined &&
                    nativeMediaRecorderConstructor.isTypeSupported('audio/webm; codecs=pcm')) {
                    _this._internalMediaRecorder = createWebmPcmMediaRecorder(_this, nativeMediaRecorderConstructor, stream, mimeType);
                }
                else {
                    _this._internalMediaRecorder = createWebAudioMediaRecorder(_this, stream, mimeType);
                }
            }
            else {
                // This is creating a native MediaRecorder just to provoke it to throw an error.
                if (nativeMediaRecorderConstructor !== null) {
                    createNativeMediaRecorder(nativeMediaRecorderConstructor, stream, options);
                }
                throw createNotSupportedError();
            }
            _this._ondataavailable = null;
            _this._onerror = null;
            _this._onpause = null;
            _this._onresume = null;
            _this._onstart = null;
            _this._onstop = null;
            return _this;
        }
        Object.defineProperty(MediaRecorder.prototype, "mimeType", {
            get: function () {
                return this._internalMediaRecorder.mimeType;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(MediaRecorder.prototype, "ondataavailable", {
            get: function () {
                return this._ondataavailable === null ? this._ondataavailable : this._ondataavailable[0];
            },
            set: function (value) {
                if (this._ondataavailable !== null) {
                    this.removeEventListener('dataavailable', this._ondataavailable[1]);
                }
                if (typeof value === 'function') {
                    var boundListener = value.bind(this);
                    this.addEventListener('dataavailable', boundListener);
                    this._ondataavailable = [value, boundListener];
                }
                else {
                    this._ondataavailable = null;
                }
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(MediaRecorder.prototype, "onerror", {
            get: function () {
                return this._onerror === null ? this._onerror : this._onerror[0];
            },
            set: function (value) {
                if (this._onerror !== null) {
                    this.removeEventListener('error', this._onerror[1]);
                }
                if (typeof value === 'function') {
                    var boundListener = value.bind(this);
                    this.addEventListener('error', boundListener);
                    this._onerror = [value, boundListener];
                }
                else {
                    this._onerror = null;
                }
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(MediaRecorder.prototype, "onpause", {
            get: function () {
                return this._onpause === null ? this._onpause : this._onpause[0];
            },
            set: function (value) {
                if (this._onpause !== null) {
                    this.removeEventListener('pause', this._onpause[1]);
                }
                if (typeof value === 'function') {
                    var boundListener = value.bind(this);
                    this.addEventListener('pause', boundListener);
                    this._onpause = [value, boundListener];
                }
                else {
                    this._onpause = null;
                }
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(MediaRecorder.prototype, "onresume", {
            get: function () {
                return this._onresume === null ? this._onresume : this._onresume[0];
            },
            set: function (value) {
                if (this._onresume !== null) {
                    this.removeEventListener('resume', this._onresume[1]);
                }
                if (typeof value === 'function') {
                    var boundListener = value.bind(this);
                    this.addEventListener('resume', boundListener);
                    this._onresume = [value, boundListener];
                }
                else {
                    this._onresume = null;
                }
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(MediaRecorder.prototype, "onstart", {
            get: function () {
                return this._onstart === null ? this._onstart : this._onstart[0];
            },
            set: function (value) {
                if (this._onstart !== null) {
                    this.removeEventListener('start', this._onstart[1]);
                }
                if (typeof value === 'function') {
                    var boundListener = value.bind(this);
                    this.addEventListener('start', boundListener);
                    this._onstart = [value, boundListener];
                }
                else {
                    this._onstart = null;
                }
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(MediaRecorder.prototype, "onstop", {
            get: function () {
                return this._onstop === null ? this._onstop : this._onstop[0];
            },
            set: function (value) {
                if (this._onstop !== null) {
                    this.removeEventListener('stop', this._onstop[1]);
                }
                if (typeof value === 'function') {
                    var boundListener = value.bind(this);
                    this.addEventListener('stop', boundListener);
                    this._onstop = [value, boundListener];
                }
                else {
                    this._onstop = null;
                }
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(MediaRecorder.prototype, "state", {
            get: function () {
                return this._internalMediaRecorder.state;
            },
            enumerable: false,
            configurable: true
        });
        MediaRecorder.prototype.pause = function () {
            return this._internalMediaRecorder.pause();
        };
        MediaRecorder.prototype.resume = function () {
            return this._internalMediaRecorder.resume();
        };
        MediaRecorder.prototype.start = function (timeslice) {
            return this._internalMediaRecorder.start(timeslice);
        };
        MediaRecorder.prototype.stop = function () {
            return this._internalMediaRecorder.stop();
        };
        MediaRecorder.isTypeSupported = function (mimeType) {
            return ((nativeMediaRecorderConstructor !== null &&
                // Bug #10: Safari does not yet implement the isTypeSupported() method.
                nativeMediaRecorderConstructor.isTypeSupported !== undefined &&
                nativeMediaRecorderConstructor.isTypeSupported(mimeType)) ||
                encoderRegexes.some(function (regex) { return regex.test(mimeType); }));
        };
        return MediaRecorder;
    }(eventTargetConstructor));
};
//# sourceMappingURL=media-recorder-constructor.js.map
